export default __webpack_public_path__ + "static/bookkeeper-launch-certificate-of-completion-a5dd3e4a0a4cc97cec49a4620824a522.png";